<template>
    <div class="landing-page-selector-container" >
        <div class="landing-page-selector-box">
            <div style="position: relative;" class="selector_box">
                <div class="link" @click="$router.push('/healthcare')">
                    <img src="/images/healthcare_logo.png" alt="" style="width: 230px;margin: auto;">
                    <div><span style="text-align: center;">Go to Kurdos Healthcare</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#fff"
                            viewBox="0 0 256 256">
                            <path
                                d="M224.49,136.49l-72,72a12,12,0,0,1-17-17L187,140H40a12,12,0,0,1,0-24H187L135.51,64.48a12,12,0,0,1,17-17l72,72A12,12,0,0,1,224.49,136.49Z">
                            </path>
                        </svg>
                    </div>
                </div>
                <div class="layer">
                    <div style="width: 100%;height: 200px;background: linear-gradient(rgba(0,0,0,0.2), transparent);">
                    </div>
                </div>
            </div>
            <div style="position: relative;overflow: hidden;" class="selector_box">
                <div class="link" @click="$router.push('/logistics')">
                    <img src="/images/logo.png" alt="" style="width: 130px;margin: auto;">
                    <div><span style="text-align: center;">Go to Kurdos Logistics</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#fff"
                            viewBox="0 0 256 256">
                            <path
                                d="M224.49,136.49l-72,72a12,12,0,0,1-17-17L187,140H40a12,12,0,0,1,0-24H187L135.51,64.48a12,12,0,0,1,17-17l72,72A12,12,0,0,1,224.49,136.49Z">
                            </path>
                        </svg>
                    </div>
                </div>
                <div class="layer">
                    <div style="width: 100%;height: 200px;background: linear-gradient(rgba(0,0,0,0.2), transparent);">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>